module.exports = __webpack_public_path__ + "img/m-banner-cookagaw-ar-SA.598c35cf.jpg";